var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import RegisteredDevices from "./RegisteredDevice/RegisteredDevices";
import { SettingContent } from "./RegisteredDevice/SettingContent";
import { useSelector } from "react-redux";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { accountDetails } from "@mainDi/webDi";
import clevertap from "clevertap-web-sdk";
import AppId from "@domains/utils/AppId";
import browserName from "@frameworks/web/utils/browserName";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { useNavigate } from "react-router-dom";
var SettingsTab = function () {
    var _a;
    var _b = __read(useState(false), 2), registeredDevicepopup = _b[0], setRegisteredDevicepopup = _b[1];
    // const [registerThisDevice, setRegisterThisDevice] = useState(false);
    var _c = __read(useState(false), 2), deviceLimit = _c[0], setDeviceLimit = _c[1];
    var device = DeviceContext();
    var navigate = useNavigate();
    var clevertapId = clevertap.getCleverTapID();
    var appid = AppId();
    // const [registeredDevice, SetregisteredDevice] = useState<boolean>(false);
    // const [payloadDesktop, setPayloadDesktop] =
    //   useState<IDeregisterDeviceRequest>();
    var _d = __read(useState(false), 2), ForgetthisDevice = _d[0], SetForgetthisDevice = _d[1];
    var getllRegisteredDevicelist = useSelector(function (state) { return state.BasicProfile.GetRegisteredDeviceReducer; });
    var listofdevices = (_a = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _a === void 0 ? void 0 : _a.dvLst;
    var getallRegisteredDevices = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, accountDetails.getPrfid()];
                case 1:
                    payload = (_a.prfId = _b.sent(),
                        _a);
                    di.basicProfile.getRegisterdDeviceData(payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var deviceRegister = function () { return __awaiter(void 0, void 0, void 0, function () {
        var registerdevicepayload, firstpopclose;
        return __generator(this, function (_a) {
            registerdevicepayload = {
                appid: appid,
                bwsNm: browserName().browserName,
                clvTpId: clevertapId,
                devNm: browserName().browserName + " " + browserName().version.fullVersion,
                plt: "EWIN",
            };
            firstpopclose = function () {
                setDeviceLimit(true);
                // setRegisterThisDevice(false);
                setRegisteredDevicepopup(false);
            };
            (listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices.length) >= 10
                ? firstpopclose()
                : (di.basicProfile
                    .registerDeviceData(registerdevicepayload)
                    .then(function (res) {
                    if (res.success == true) {
                        getallRegisteredDevices();
                        setRegisteredDevicepopup(false);
                        // setRegisterThisDevice(false);
                    }
                })
                    .catch(function (err) {
                    console.log(err);
                    setRegisteredDevicepopup(false);
                }),
                    (device === null || device === void 0 ? void 0 : device.isMobile) && navigate("/register-device"));
            return [2 /*return*/];
        });
    }); };
    // const deregistereddevices = () => {
    //   const deregisterpayload: IDeregisterDeviceRequest = {
    //     clvrTpId: payloadDesktop?.clvrTpId,
    //     appId: payloadDesktop?.appId,
    //   };
    //   const isCurrentDevice = deregisterpayload.appId == appid ? true : false;
    //   di.basicProfile.deRegisterDeviceData(deregisterpayload).then((res) => {
    //     res.success == true;
    //     {
    //       if (isCurrentDevice) {
    //         // localStorage.clear();
    //         clearStorageOnLogout();
    //         navigate("/login");
    //       } else {
    //         getallRegisteredDevices();
    //         SetForgetthisDevice(false);
    //       }
    //     }
    //   }).catch((err)=>{console.log(err)});
    // };
    var deleteOldDevice = function () {
        var _a, _b;
        var deregisterpayload = {
            clvrTpId: (_a = listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices[0]) === null || _a === void 0 ? void 0 : _a.clvrTpId,
            appId: (_b = listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices[0]) === null || _b === void 0 ? void 0 : _b.appId,
        };
        di.basicProfile
            .deRegisterDeviceData(deregisterpayload)
            .then(function (res) {
            res.success == true;
            {
                setDeviceLimit(false);
                deviceRegister();
                getallRegisteredDevices();
                SetForgetthisDevice(false);
            }
        })
            .catch(function (err) {
            console.log(err);
        });
        (device === null || device === void 0 ? void 0 : device.isMobile) && navigate("/register-device");
    };
    React.useEffect(function () {
        getallRegisteredDevices();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(RegisteredDevices, { listofdevices: listofdevices, 
                    // getallRegisteredDevices={getallRegisteredDevices}
                    deviceRegister: deviceRegister, 
                    // deregistereddevices={deregistereddevices}
                    deleteOldDevice: deleteOldDevice, 
                    // payloadDesktop={payloadDesktop}
                    // setPayloadDesktop={setPayloadDesktop}
                    // ForgetthisDevice={ForgetthisDevice}
                    // SetForgetthisDevice={SetForgetthisDevice}
                    deviceLimit: deviceLimit, setDeviceLimit: setDeviceLimit })),
            React.createElement("div", null,
                React.createElement(SettingContent, null)))));
};
export default SettingsTab;
